export enum IMG_TYPE {
    SVG = 'svg',
    IMG = 'img',
    VIDEO = 'webm',
    GIF = 'gif'
}